module.exports = __webpack_public_path__ + "img/8.5f8bfff1.svg";